import { StyledLabel } from "./label.scss";

const Label = ({ text, borderColor }) => (
  <StyledLabel className="generic-text" borderColor={borderColor}>
    {text}
  </StyledLabel>
);

export default Label;
